module.exports = __webpack_public_path__ + "static/media/calandrias.59a452f1.webp";